import { TOKEN } from '../config/localstorage_keys';
import api from './api';
import { LOGIN_ENDPOINT, USERLOGIN } from './URLS';

import { clearLocalStorage, setLocalStorage } from '../utils/strorage';

const login = (username, password) => {
  return api
    .post(LOGIN_ENDPOINT, {
      username,
      password,
    })
    .then((response) => {
      setLocalStorage(TOKEN, response.data.response.accessToken);
      localStorage.setItem("mobile", response.data.response?.mobile);
      localStorage.setItem("name", response.data.response?.name);
      localStorage.setItem("role", response.data.response?.roles);
      // null (not []) when the backend hasn't sent `access` yet, so we can tell
      // "not implemented for this account" apart from "explicitly zero access".
      const hasAccessField = Object.prototype.hasOwnProperty.call(response.data.response ?? {}, 'access');
      localStorage.setItem("access", JSON.stringify(hasAccessField ? response.data.response.access : null));
      if (response.data.response?.roles?.includes('TEAM_KARAN')) {
        localStorage.setItem("productId", response.data.response?.products);
      }
      return response;
    })
    .catch((err) => {
      return err;
    });
};

const logout = () => {
  clearLocalStorage();
};

export { login, logout };
